import * as React             from 'react';
import { StatelessComponent } from 'react';
import icons                  from '../icons';
import Expire                 from './Expire';

interface Props {
    message: string,
    type?: string,
    delay?: number,
    condition?: boolean,
}

export const Alert: StatelessComponent<Props> = ({ condition, message, type, delay }) => {
    return condition && message ? (
        <div className="alert">
            <Expire delay={delay}>
                <div className={'alert__container ' + type}>
                    <div className="alert__message">
                        {icons.alertCircle} {message}
                    </div>
                </div>
            </Expire>
        </div>
    ) :
    null;
};

Alert.defaultProps = {
    condition: true,
    type: 'error',
};

export default Alert;



// WEBPACK FOOTER //
// ./src/components/Alert.tsx